/**
 * Represents either a reference to a particular model ID or the _lack_ of a reference
 * to a model ID. A removed model ID only makes sense in the context of merging strata.
 */
let ModelReference;
(function (_ModelReference) {
  function isRemoved(reference) {
    return reference ? reference.removed !== undefined : false;
  }
  _ModelReference.isRemoved = isRemoved;
})(ModelReference || (ModelReference = {}));
export default ModelReference;